module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0678.c6369344.jpg";